import Typography from "@mui/material/Typography";
import { BoxStyled, DialogComponentStyled } from "./dialog-component.styles";
import { Close } from "@mui/icons-material";
import Fade from "@mui/material/Fade";
import { Box } from "@mui/material";
import { DialogComponentProps } from "./types";

const DialogComponent: React.FC<DialogComponentProps> = ({
  title,
  content,
  open,
  onClose,
  width,
}) => {
  return (
    <DialogComponentStyled
      open={open}
      onClose={onClose}
      closeAfterTransition
      scroll="body"
      width={width}
      className="dialog-wrapper"
    >
      <Fade in={open}>
        <BoxStyled>
          <div className="title-container">
            {title && <Typography id="modal-modal-title">{title}</Typography>}
            <span className="close-icon" onClick={onClose}>
              <Close />
            </span>
          </div>
          <Box className="content-container">{content}</Box>
        </BoxStyled>
      </Fade>
    </DialogComponentStyled>
  );
};

export default DialogComponent;
